import axios from 'axios';
import { dateFormatter } from '../dateFormatter/formatter';
import { cookieHelper } from '../cookieHelper';

import { getTestDriveSessionId } from '../urlConstructor/initTestDriveSession';
import { testDriveCatalog } from '../urlConstructor/testDriveCatalog';
import { testDriveSending } from '../urlConstructor/testDriveSending';

export default  {
    state: {
        testDrive: {
            sessionId: null,
            unforeseenSessionExpiration: false,
            sessionExpirationTime: null,
            cities: null,
            dateTimes: null,
            dealers: [],
            models: []
        },

        testDriveLimit: {
            expirationTime: 0,
            limit: 0
        },

        testDriveSelected: {
            model: '',
            dealer: '',
            vehicle: '',
            date: '',
            time: '',
            clientInfo: {
                firstName: '',
                middleName: '',
                lastName: '',
                phone: '',
                email: ''
            },
            unsentClientInfo: {
                firstName: '',
                middleName: '',
                lastName: '',
                phone: '',
                email: ''
            },
            finished: false
        },
    },


    getters: {
        testDriveConfig(state) {
            return {
                headers: {
                    'JLR-Session-Id': state.testDrive.sessionId
                }
            }
        },
        testDriveFormattedTime(state) {
            const params = {
                date: state.testDriveSelected.date,
                time: state.testDriveSelected.time,
                locale: state.locale
            };
            return dateFormatter(params);
        }
    },


    mutations: {
        setTestDriveLimit: function(state, payload) {
            state.testDriveLimit = payload;
        },
        setTestDriveSessionId: function (state, payload) {
            state.testDrive.sessionId = payload;
            state.testDrive.unforeseenSessionExpiration = false;
        },
        setTestDriveSessionExpirationTime: function (state, payload) {
            state.testDrive.sessionExpirationTime = Date.now() + payload * 1000;
        },

        setTestDriveCities: function (state, payload) {
            state.testDrive.cities = payload;
        },

        changeTestDriveDealers: function(state, payload) {
            state.testDrive.dealers = payload;
        },
        changeTestDriveTimeSlots: function(state, payload) {
            state.testDrive.dateTimes = payload;
        },
        changeTestDriveModels: function(state, payload) {
            state.testDrive.models = payload.models;
        },


        setTestDriveDealer: function (state, payload) {
            state.testDriveSelected.dealer = payload.dealer;
            state.testDriveSelected.vehicle = payload.vehicle;
        },
        setTestDriveVehicle: function (state, payload) {
            state.testDriveSelected.vehicle = payload;
        },
        setTestDriveDateTime: function (state, payload) {
            state.testDriveSelected.date = payload.date;
            state.testDriveSelected.time = payload.time;
        },
        setTestDriveModel: function (state, payload) {
            state.testDriveSelected.model = payload;
        },
        setTestDriveClientInfo: function (state, payload) {
            state.testDriveSelected.clientInfo = payload;
        },
        setTestDriveUnsentClientInfo: function (state, payload) {
            state.testDriveSelected.unsentClientInfo = payload;
        },


        finishedTestDriveBooking: function (state) {
            state.testDriveSelected.finished = true;
        },

        clearTestDriveDealer: function(state) {
            state.testDriveSelected.dealer = '';
        },
        clearTestDriveDateTime: function(state) {
            state.testDriveSelected.date = '';
            state.testDriveSelected.time = '';
        },
        clearTestDriveForm: function (state) {
            state.testDrive.sessionId = null;
            state.testDrive.sessionExpirationTime = null;
            state.testDrive.unforeseenSessionExpiration = false;

            state.testDriveSelected =  {
                model: '',
                dealer: '',
                date: '',
                time: '',
                clientInfo: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    phone: '',
                    email: ''
                },
                unsentClientInfo: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    phone: '',
                    email: ''
                },
                finished: false
            }
        }
    },



    actions: {
        setTestDriveSessionId(context) {
            const urlParams = {
                brandId: context.state.brandId,
                visitorId: cookieHelper.get('JLR_WIDGET_VISITOR_ID')
            };

            if (context.state.dealerId) {
                urlParams.dealerId = context.state.dealerId;
            }

            const url = getTestDriveSessionId(urlParams);

            return axios.get(url).then(res => {
                context.commit('setTestDriveSessionId', res.data.session_id);
                context.commit('setTestDriveSessionExpirationTime', res.data.lifetime);
            })
        },

        setTestDriveLimit(context) {
            const url = testDriveCatalog.getLimit();
            return axios.get(url).then(res => {
                const expirationTime = Date.now()/1000 + res.data.limit_lifetime;
                const limitInfo = {
                    expirationTime: expirationTime,
                    limit: res.data.request_limit
                };
                context.commit('setTestDriveLimit', limitInfo);
            })
        },

        changeTestDriveDealers(context, payload) {
            const urlParams = {
                brandId: context.state.brandId,
                placeId: payload.placeId,
                cityId: payload.cityId
            };
            const url = testDriveCatalog.getDealers(urlParams);

            return axios.get(url, context.getters.testDriveConfig)
                .then(res => {
                    context.commit('changeTestDriveDealers', res.data.dealers);
                })
                .catch(err => {
                    context.commit('changeTestDriveDealers', []);
                })
        },
        changeTestDriveTimeSlots(context) {
            const urlParams = {
                brandId: context.state.brandId,
                vehicleId: context.state.testDriveSelected.vehicle.id
            };

            const url = testDriveCatalog.getTimeSlots(urlParams);

            return axios.get(url, context.getters.testDriveConfig).then(res => {
                context.commit('changeTestDriveTimeSlots', res.data.time_slots)
            });
        },
        changeTestDriveModels(context) {
            const urlParams = {
                brandId: context.state.brandId
            };
            if (context.state.dealerId) {
                urlParams.dealerId = context.state.dealerId;
            }
            const url = testDriveCatalog.getModels(urlParams);

            axios.get(url).then(res => {
                context.commit('changeTestDriveModels', {
                    models: res.data.models
                })
            })
        },


        setTestDriveModel(context, payload){
            const urlParams = {
                brandId: context.state.brandId,
                modelId: payload.id
            };
            if (context.state.dealerId) {
                urlParams.dealerId = context.state.dealerId;
            }

            const url = testDriveSending.sendModel(urlParams);

            return axios.post(url, null, context.getters.testDriveConfig)
                .then(res => {
                    context.commit('setTestDriveModel', payload);

                    if(res.data.cities) {
                        context.commit('setTestDriveCities', res.data.cities);
                    }
                })
        },

        setTestDriveDateTime(context, payload){
            const urlParams = {
                brandId: context.state.brandId,
                timeSlotId: payload.time.id
            }

            const url = testDriveSending.sendTimeSlot(urlParams);

            return axios.get(url, context.getters.testDriveConfig).then(res => {
                context.commit('setTestDriveDateTime', payload)
            });
        },
        setTestDriveDealer({commit}, payload){
            commit('setTestDriveDealer', payload)
        },
        setTestDriveClientInfo(context, payload){
            const urlParams = {
                brandId: context.state.brandId
            };

            const url = testDriveSending.sendClientInfo(urlParams);

            const userData = {
                first_name: payload.firstName,
                second_name: payload.lastName,
                patronymic_name: payload.middleName,
                email: payload.email,
                mobile_phone: payload.phone.replace(/[()-]/g, '')
            };

            return axios.post(url, userData, context.getters.testDriveConfig).then(res => {
                context.commit('setTestDriveClientInfo', payload)
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/TestDrive.js